import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  isFailure: false,
  isPending: false,
  isSuccessful: false,
};

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.addPlanzoneResourcesToProjectRequested]: setRequestStateToPending,
    [events.addPlanzoneResourcesToProjectSucceeded]: setRequestStateToSuccess,
    [events.addPlanzoneResourcesToProjectFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isAddPlanzoneResourcesToProjectRequestFailure() {
      return getState().isFailure;
    },
    isAddPlanzoneResourcesToProjectRequestPending() {
      return getState().isPending;
    },
    isAddPlanzoneResourcesToProjectRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
